import FileSaver from 'file-saver'
import moment from 'moment'

import Make from '../REST/make'

const make = Make('', true)

export const unsubscribeMarketing = async ({ uid }): Promise<boolean | any> => {
  const req = await make.get({
    endpoint: `account/unsubscribe-marketing?uid=${uid}`,
    // options: {
    //   'Content-Type': 'multipart/form-data',
    // },
    // data,
  })

  if (req.success && req.res.status === 200) {
    return true
  }

  return req.res
}

export const getDropdownUsageReport = async (): Promise<boolean> => {
  const req = await make.get({
    endpoint: `track/download-generator-audit?includeNonSelectFields=true`,
    options: {
      headers: {
        'Content-Type':
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  })

  if (!req.success || req.res.status === 404) {
    return false
  }

  if (req.res.data) {
    const blob = new Blob([new Uint8Array(req.res.data)], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const now = new Date(Date.now())

    await FileSaver.saveAs(
      blob,
      `Uplifter - Dropdown Usage Data - ${moment(now).format(
        'YYYY-MM-DD',
      )}.xlsx`,
    )
  }

  return true
}
